import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

import SyncSalesButtonSvg from '@web/assets/svg/integrations/sync-sales-button.svg';

type ButtonWrapperProps = {
  showPremiumGuard: boolean;
};

export const ButtonWrapper = styled.button<ButtonWrapperProps>`
  background-color: transparent;
  display: flex;
  height: 38.5px;
  align-items: center;
  border: solid 1px #d8d8d8;
  border-radius: 3px;
  opacity: ${(props) => (props.showPremiumGuard ? '0.5' : '0.65')};
  padding: 0;
  text-transform: none !important;
  width: 36px;

  &:not([disabled]):hover {
    background-color: rgba(0, 128, 255, 0.08);
    opacity: 1;
  }
`;

export const ModalWrapper = styled.div`
  text-transform: none !important;
`;

export const ModalReactInnerWrapper = styled.div`
  text-transform: none !important;
  height: 420px;
`;

type ButtonIconProps = {
  showPremiumGuard: boolean;
};

export const ButtonIcon = styled(SyncSalesButtonSvg)<ButtonIconProps>`
  background-color: transparent;
  opacity: ${(props) => (props.showPremiumGuard ? '0.65' : '1')};
  outline: none;
`;

export const DontAskMeAgainContainer = styled(Row)`
  margin-top: 20px;
`;

export const TooltipContentWrapper = styled.div`
  text-align: left;
`;

export const Flag = styled.div`
  display: inline-block;
  color: #7a6dc9;
  padding: 2px 8px;
  background-color: #ffffff;
  border-radius: 4px;
  margin-bottom: 2px;
  margin-right: 2px;
`;
